/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Gap_Frames_HelpInputs */



/**
* | output |
* | --- |
* | "Minimum gap between events in frames" |
*
* @param {Event_Gap_Frames_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_gap_frames_help = /** @type {((inputs?: Event_Gap_Frames_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Gap_Frames_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Écart minimum entre événements en images")
	if (locale === "de") return /** @type {LocalizedString} */ ("Minimaler Abstand zwischen Ereignissen in Frames")
	if (locale === "it") return /** @type {LocalizedString} */ ("Distanza minima tra gli eventi nei frame")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальный промежуток между событиями в кадрах")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espacio mínimo entre eventos en los fotogramas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("帧中事件之间的最小间隔")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレーム内のイベント間の最小ギャップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़्रेमों में घटनाओं के बीच न्यूनतम अंतराल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Intervalo mínimo entre eventos em frames")
	return /** @type {LocalizedString} */ ("Minimum gap between events in frames")
});